import { addCommonListener } from './addCommonListener'
import { PlatformListener, KeyboardListener, BackButtonListener } from './addPlatformListener'

export {
    addCommonListener,
    PlatformListener,
    KeyboardListener,
    BackButtonListener,
}